import { render, staticRenderFns } from "./GeneroButtons.vue?vue&type=template&id=11c6965e&scoped=true&"
import script from "./GeneroButtons.vue?vue&type=script&lang=js&"
export * from "./GeneroButtons.vue?vue&type=script&lang=js&"
import style0 from "./GeneroButtons.vue?vue&type=style&index=0&id=11c6965e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6965e",
  null
  
)

export default component.exports